function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1.022 24h12.957A1.022 1.022 0 0015 22.979v-8.66a1.019 1.019 0 00-.062-.338.476.476 0 00-.031-.062 1.031 1.031 0 00-.096-.194l-2.356-3.297a1.025 1.025 0 00-.832-.428H3.377a1.024 1.024 0 00-.832.428L.19 13.725a1.021 1.021 0 00-.098.196.48.48 0 00-.03.057A1.016 1.016 0 000 14.32v8.66A1.023 1.023 0 001.022 24zM1 22.979l.004-8.327h12.995L13.98 23zm10.64-11.97h.001l1.884 2.643H8V11h3.623a.02.02 0 01.018.009zM3.378 11H7v2.652H1.474z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.251 18h-3.5a.787.787 0 00-.75.82v1.347a.787.787 0 00.738.832l.012.001h3.5a.787.787 0 00.751-.82v-1.347a.787.787 0 00-.738-.832zm-.25 2h-3v-1h3zM18.5 11A5.5 5.5 0 1124 5.5a5.507 5.507 0 01-5.5 5.5zm0-10A4.5 4.5 0 1023 5.5 4.505 4.505 0 0018.5 1z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.805 8.024a1.12 1.12 0 01-.676-.227 3.51 3.51 0 01-.113-.097l-1.254-1.255a.5.5 0 01.707-.707l1.25 1.25a.146.146 0 00.19-.014l2.42-3.227a.5.5 0 01.8.6l-2.421 3.227a1.12 1.12 0 01-.744.439 1.09 1.09 0 01-.16.01z"
});

function SvgArtifactApproved(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2, _ref3);
}

export default __webpack_public_path__ + "artifactApproved.6aaf8.svg";
export { SvgArtifactApproved as ReactComponent };